"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FavoritesProvider", {
  enumerable: true,
  get: function () {
    return _FavoritesProvider.FavoritesProvider;
  }
});
Object.defineProperty(exports, "favoritesContext", {
  enumerable: true,
  get: function () {
    return _favoritesContext.favoritesContext;
  }
});
Object.defineProperty(exports, "favoritesContextDefaultValue", {
  enumerable: true,
  get: function () {
    return _favoritesContext.favoritesContextDefaultValue;
  }
});
Object.defineProperty(exports, "useFavorites", {
  enumerable: true,
  get: function () {
    return _favoritesContext.useFavorites;
  }
});
var _FavoritesProvider = require("./FavoritesProvider");
var _favoritesContext = require("./favoritesContext");
